var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "webContent flex",
      staticStyle: { "z-index": "auto" },
      attrs: { scroll: "" }
    },
    [
      _c("div", { staticStyle: { height: "100%", overflow: "auto" } }, [
        _c("div", { staticClass: "model-title" }, [_vm._v("车型对比")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "top-2" },
          [
            _c("div", { staticClass: "side" }, [
              _c(
                "div",
                { staticClass: "title", staticStyle: { "border-bottom": "0" } },
                [_vm._v("车型信息")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.highLight,
                        callback: function($$v) {
                          _vm.highLight = $$v
                        },
                        expression: "highLight"
                      }
                    },
                    [_vm._v("高亮显示不同")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.hideSame,
                        callback: function($$v) {
                          _vm.hideSame = $$v
                        },
                        expression: "hideSame"
                      }
                    },
                    [_vm._v("隐藏显示相同项")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.list, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "car",
                  staticStyle: { display: "inline-block", position: "relative" }
                },
                [
                  v.carName
                    ? _c("div", { staticClass: "candelete2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "delete",
                            on: {
                              click: function($event) {
                                return _vm.deleteCar(i)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: require("./images/delete.png") }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pic" }, [
                          v.imageUrl
                            ? _c("img", {
                                staticClass: "showImg",
                                attrs: { src: v.imageUrl }
                              })
                            : _c("img", {
                                staticClass: "defaultImg",
                                attrs: { src: require("./images/add.png") }
                              })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(v.carName || ""))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "change-btn",
                            on: {
                              click: function($event) {
                                return _vm.changeCar(i, v)
                              }
                            }
                          },
                          [_vm._v("更换")]
                        )
                      ])
                    : _c("div", { staticClass: "canadd" }, [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("div", { staticClass: "empty-name" }, [
                          _vm._v(_vm._s(""))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "change-btn",
                            on: {
                              click: function($event) {
                                return _vm.changeCar(i)
                              }
                            }
                          },
                          [_vm._v("添加车型")]
                        )
                      ])
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "content", staticStyle: { padding: "0" } }, [
          _c(
            "div",
            { staticClass: "item-box" },
            _vm._l(_vm.itemList, function(v, i) {
              return _c("div", { key: i, staticClass: "item-li" }, [
                (v.hidden
                ? false
                : _vm.hideSame && v.hiddenSame
                ? false
                : true)
                  ? _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          class:
                            v.value === "_title" ? "second-title" : "side-row"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(v.label) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            v.value === "_title" ? "second-title" : "side-row",
                          style:
                            v.value === "_title"
                              ? ""
                              : "border-left: 1px solid #d0d1d4"
                        },
                        [
                          v.value === "_title"
                            ? _c(
                                "span",
                                { staticStyle: { color: "transparent" } },
                                [_vm._v("-")]
                              )
                            : _c("span", [
                                _vm.list[0]["carName"]
                                  ? _c(
                                      "span",
                                      {
                                        style:
                                          _vm.highLight && v.highLight
                                            ? "color: #d5001c"
                                            : "color: #333"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.list[0][v.value] || "-"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v(_vm._s("-"))])
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            v.value === "_title" ? "second-title" : "side-row",
                          style:
                            v.value === "_title"
                              ? ""
                              : "border-left: 1px solid #d0d1d4"
                        },
                        [
                          v.value === "_title"
                            ? _c(
                                "span",
                                { staticStyle: { color: "transparent" } },
                                [_vm._v("-")]
                              )
                            : _c("span", [
                                _vm.list[1]["carName"]
                                  ? _c(
                                      "span",
                                      {
                                        style:
                                          _vm.highLight && v.highLight
                                            ? "color: #d5001c"
                                            : "color: #333"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.list[1][v.value] || "-"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v(_vm._s("-"))])
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            v.value === "_title" ? "second-title" : "side-row",
                          style:
                            v.value === "_title"
                              ? ""
                              : "border-left: 1px solid #d0d1d4"
                        },
                        [
                          v.value === "_title"
                            ? _c(
                                "span",
                                { staticStyle: { color: "transparent" } },
                                [_vm._v("-")]
                              )
                            : _c("span", [
                                _vm.list[2]["carName"]
                                  ? _c(
                                      "span",
                                      {
                                        style:
                                          _vm.highLight && v.highLight
                                            ? "color: #d5001c"
                                            : "color: #333"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.list[2][v.value] || "-"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v(_vm._s("-"))])
                              ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "foo-tip" }, [
          _vm._v(" ※ 部分车型的标准配置或选装配置可能会被临时调整，敬请理解! ")
        ]),
        _vm._v(" "),
        _vm.isChangeParent
          ? _c("div", { staticClass: "collectBase" }, [
              _c("div", { staticClass: "collectBase-box" }, [
                _c("div", { staticClass: "collectBase-top" }, [
                  _c("div", {
                    staticClass: "collectBase-close",
                    on: { click: _vm.closeCollectBase }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "collectBase-list" },
                  _vm._l(_vm.options, function(v, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "collectBase-li df cf wao",
                        class: { cur: _vm.choose.includes(v.value) },
                        on: {
                          click: function($event) {
                            return _vm.chooseCollectBase(v.value)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "collectBase-title" }, [
                          _vm._v(_vm._s(v.label ? _vm.replace(v.label) : ""))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isChangeSon
          ? _c("div", { staticClass: "collectBase" }, [
              _c("div", { staticClass: "collectBase-box" }, [
                _c("div", { staticClass: "collectBase-top" }, [
                  _c("div", {
                    staticClass: "collectBase-close",
                    on: { click: _vm.closeCollectBase2 }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "collectBase-list" },
                  _vm._l(_vm.modelList, function(v, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "collectBase-li df cf wao",
                        class: { cur: _vm.choose.includes(v.value) },
                        on: {
                          click: function($event) {
                            return _vm.chooseCollectBase2(v.value)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "collectBase-title" }, [
                          _vm._v(_vm._s(v.label ? _vm.replace(v.label) : ""))
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collectBase-btn",
                    on: { click: _vm.resCollectBase2 }
                  },
                  [_vm._v("确认")]
                )
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pic" }, [
      _c("img", {
        staticClass: "defaultImg",
        attrs: { src: require("./images/add.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95b55cbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95b55cbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/home/carCompare/index.vue
// module id = null
// module chunks = 